import { logger } from 'monitor';
import { forwardRef } from 'react';

import { useForwardRef } from '../../hooks/useForwardRef/useForwardRef';
import { Upload } from '../../icons';
import { FilePicker } from '../FilePicker/FilePicker';

type BaseProps = {
  label?: string;
  disabled?: boolean;
  loading?: boolean;
  hide?: boolean;
  accept?: string;
  slotsProps?: {
    buttonProps?: React.ComponentProps<typeof FilePicker>['buttonProps'];
  };
};

type SingleFileProps = BaseProps & {
  multiple?: false;
  onSelectFile: (file: File) => void;
  onSelectFiles?: never;
};

type MultipleFileProps = BaseProps & {
  multiple: true;
  onSelectFile?: (file: File) => void;
  onSelectFiles: (files: File[]) => void;
};

type Props = SingleFileProps | MultipleFileProps;

export const PhotoFilePicker = forwardRef(function PhotoFilePicker(
  {
    onSelectFile,
    onSelectFiles,
    label = 'Upload photo',
    hide = false,
    multiple = false,
    accept = 'image/*;capture=camera',
    slotsProps,
  }: Props,
  ref: React.Ref<HTMLInputElement>
) {
  const inputRef = useForwardRef(ref);
  return (
    <FilePicker
      hide={hide}
      multiple={multiple}
      label={label}
      accept={accept}
      onChange={(event) => {
        if (!event.target.files?.length) {
          logger.error('No file selected');
          return;
        }
        const files = Array.from(event.target.files);
        if (onSelectFiles && multiple) {
          onSelectFiles(files);
        } else {
          for (const file of files) {
            onSelectFile?.(file);
          }
        }
      }}
      icon={<Upload />}
      ref={inputRef}
      onClick={() => {
        if (inputRef.current) {
          inputRef.current.value = '';
        }
      }}
      buttonProps={slotsProps?.buttonProps}
    />
  );
});
